const RestaurantByCity = [
    {
      text: "Ayodhya",
      link: "https://www.swiggy.com/city/ayodhya",
    },
    {
      text: "Bangalore",
      link: "https://www.swiggy.com/city/bangalore",
    },
    {
      text: "Gurgaon",
      link: "https://www.swiggy.com/city/gurgaon",
    },
    {
      text: "Hyderabad",
      link: "https://www.swiggy.com/city/hyderabad",
    },
    {
      text: "Delhi",
      link: "https://www.swiggy.com/city/delhi",
    },
    {
      text: "Mumbai",
      link: "https://www.swiggy.com/city/mumbai",
    },
    {
      text: "Pune",
      link: "https://www.swiggy.com/city/pune",
    },
    {
      text: "Jaipur",
      link: "https://www.swiggy.com/city/jaipur",
    },
    {
      text: "Lucknow",
      link: "https://www.swiggy.com/city/lucknow",
    },
    {
      text: "Faizabad",
      link: "https://www.swiggy.com/city/faizabad",
    },
    {
      text: "Dehradun",
      link: "https://www.swiggy.com/city/dehradun",
    },
    {
      text: "Noida",
      link: "https://www.swiggy.com/city/noida",
    },
    {
      text: "Kanpur",
      link: "https://www.swiggy.com/city/kanpur",
    },
    {
      text: "Agra",
      link: "https://www.swiggy.com/city/agra",
    },
    {
      text: "Kota",
      link: "https://www.swiggy.com/city/kota",
    },
    {
      text: "Allahabad",
      link: "https://www.swiggy.com/city/allahabad",
    },
    {
      text: "Bareilly",
      link: "https://www.swiggy.com/city/bareilly",
    },
    {
      text: "Meerut",
      link: "https://www.swiggy.com/city/meerut",
    },
    {
      text: "Goa",
      link: "https://www.swiggy.com/city/central-goa",
    },
    {
      text: "Varanasi",
      link: "https://www.swiggy.com/city/varanasi",
    },
  ];
  
  export default RestaurantByCity;
  